import { SupportedLocale } from '../../constants'
import { ListFieldDefinition } from '../../definitions/field-definitions/list-fields-definition'
import { Entity } from '../entity'
import { FieldValue } from './field.class'

export class ListValue extends FieldValue<Entity[]> {
  public isDirty = false

  constructor() {
    super()
  }

  public mapField(field: ListValue, filedDef: ListFieldDefinition): void {
    if (field.value) {
      this.value = []
      field.value.forEach((entity) => {
        const row = { ...entity }
        row.entityName = filedDef.entityName
        filedDef.fields.forEach((fieldDef) => {
          const fieldValue = row.fields[fieldDef.name]
          const fieldValueInstance = fieldDef.getFieldValue()
          if (fieldValue) fieldValueInstance.mapField(fieldValue, fieldDef)
          row.fields[fieldDef.name] = fieldValue ? fieldValueInstance : null
        })
        this.value?.push(row)
      })
    }
  }

  /**
   * string representation of the list,
   * the fields are separated by: -
   * the rows are separated by ;
   * @param args the field to represent, if null the entire row will be used
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public toStringForView(lang?: SupportedLocale, ...args: any[]): string {
    const result: string[] = []
    let resultString = null
    const argsFiltered = args.filter((a) => !!a)
    const descFieldsArg = argsFiltered.length ? argsFiltered[0] : ''
    const splitted = descFieldsArg
      .replace(/\s+/g, '')
      .split(',')
      .filter((s: string) => s != '')

    if (this.value) {
      this.value.forEach((entity) => {
        const row: string[] = []
        const fieldKeys = Object.keys(entity.fields)
        const descFields = splitted.length > 0 ? splitted : fieldKeys
        const filteredKeys = fieldKeys.filter((f) => descFields.includes(f))
        filteredKeys.forEach((fkey) => {
          const value = entity.fields[fkey]
          if (value) row.push(value.toStringForView(lang))
        })
        const rowString = row.join(' - ')
        result.push(rowString)
      })
      resultString = result.join('; ')
    }

    return resultString as string
  }

  public isEmpty(): boolean {
    return !this.value || this.value.length === 0
  }

  public IsUnique(fields: string): boolean {
    const splitted = fields.split(',')
    let isUnique = true
    let i = 0
    let j = 0
    if (this.value) {
      for (i = 0; i < this.value.length; i++) {
        for (j = i + 1; j < this.value.length; j++) {
          const row1 = this.value[i]
          const row2 = this.value[j]
          if (this.sameRow(row1, row2, splitted)) {
            isUnique = false
          }
        }
      }
    }
    return isUnique
  }

  public override clone(): ListValue {
    const cloned = super.clone() as ListValue
    cloned.value = cloned.value?.map((row) => {
      const clonedRow = { ...row } as Entity
      clonedRow.fields = { ...clonedRow.fields }
      Object.keys(row.fields).forEach((key) => {
        const clonedField = row.fields[key]?.clone() as FieldValue<any>
        clonedRow.fields[key] = clonedField
      })
      return clonedRow
    })
    return cloned
  }

  private sameRow(row1: Entity, row2: Entity, fields: string[]): boolean {
    let result = true
    fields.forEach((field) => {
      if (row1.fields[field] != null && row2.fields[field] != null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        result = result && (row1.fields[field] as FieldValue<any>).isEqual(row2.fields[field] as FieldValue<any>)
      } else {
        result = false
      }
    })
    return result
  }
}
